import React, { useEffect } from 'react'

interface MessagePopupProps {
    onClose: () => void;
}

const MessegePopupClient: React.FC<MessagePopupProps> = ({onClose}) => {

    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000); // Close after 3 seconds
        return () => clearTimeout(timer); // Cleanup the timer on unmount
    }, [onClose]);


     const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
             if (e.target === e.currentTarget) {
                 onClose();
             }
        };
  return (
    <div
            onClick={handleOverlayClick}
            style={{
                position: 'absolute',
                top: 0,
                left: '50%',
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgb(51, 129, 252)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 270,
                    height: 150,
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center',
                    color: 'rgb(51, 129, 252)',
                }}>
                {/* create messege for success from server */}
                <h2>עדכון הנתונים בוצע בהצלחה</h2>
                
            </div>
        </div>
  )
}

export default MessegePopupClient